import VenueBasedMembershipGroupRepository from "@app-contexts/dashboard/features/memberships/data/repositories/VenueBasedMembershipGroupRepository";
import { ITEM_TYPES_MAP } from "@shared/constants/enums";
import { useAnalyticsContext } from "@shared/contexts/AnalyticsContext/useAnalyticsContext";
import useAnalytics from "@shared/lib/analytics/hooks/useAnalytics";
import { GtagItemType } from "@shared/lib/analytics/types/analytics-types";
import PublicBasedMembershipGroupRepository from "@shared/modules/memberships/data/repositories/PublicBasedMembershipGroupRepository";
import { PublicMembershipLevelSerializer } from "@shared/modules/memberships/types";
import { UseModelServiceType } from "@shared/services/api/hooks/useModelService";
import { useEffect } from "react";

export default function useItemGroupMembershipGroup(
  membershipGroupId: number,
  membershipLevelId: number | undefined,
  membershipService: () => UseModelServiceType<
    PublicBasedMembershipGroupRepository | VenueBasedMembershipGroupRepository
  >,
  updateTrackingBasketData: ((input: GtagItemType) => void) | undefined,
  itemGroupId?: number
) {
  const { enableAnalytics } = useAnalyticsContext();
  const analytics = useAnalytics();

  const { useRetrieve } = membershipService();
  const { data: groupData, isFetching } = useRetrieve(membershipGroupId, {
    options: {
      enabled: Boolean(membershipGroupId),
    },
  });

  useEffect(() => {
    // propagates fetched data up to the public checkout context
    // so the data can be used for GTAG tracking
    // Note: updateTrackingBasketData is only used in the public checkout context
    if (groupData && membershipLevelId && updateTrackingBasketData) {
      const levelInBasket = (
        groupData.membership_levels as PublicMembershipLevelSerializer[]
      )?.find((ml) => ml.id === membershipLevelId);

      if (levelInBasket && enableAnalytics) {
        const trackingData = analytics.formatGtagTrackingData(
          Number(itemGroupId),
          groupData.name,
          levelInBasket?.name,
          ITEM_TYPES_MAP.ITEM_TYPE_MEMBERSHIP.id
        );
        updateTrackingBasketData(trackingData);
      }
    }
  }, [groupData, membershipLevelId, updateTrackingBasketData]);

  return { groupData, isFetching };
}
